import { parsePhoneNumber } from 'libphonenumber-js';

/** Build `code` / `phone` fields expected by PUT /account/:id. */
export function buildAccountPhonePayload(
    fullPhone: string | undefined,
    dialCode: string | number | null | undefined,
    nationalDigits: string | null | undefined
): { code: string; phone: string } {
    const trimmed = (fullPhone ?? '').trim();
    if (trimmed) {
        try {
            const parsed = parsePhoneNumber(trimmed);
            if (parsed) {
                return {
                    code: `+${parsed.countryCallingCode}`,
                    phone: parsed.nationalNumber,
                };
            }
        } catch {
            // fall through to dial/national parts
        }
    }

    if (dialCode != null && nationalDigits != null && nationalDigits !== '') {
        const code = String(dialCode).replace(/^\+/, '');
        return { code: `+${code}`, phone: nationalDigits };
    }

    return { code: '', phone: '' };
}
